import moment from "moment";

const renderFormatedDate = (params) => {
  if (!params.value) return "";

  const date = moment(params.value);

  return (
    <div>
      <span>{date.format("DD MMM/YY")}</span><br />
      <span>{date.format("hh:mm A")}</span>
    </div>
  );
};

export default renderFormatedDate;